import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import RadioButton from "../../../../../../../components/radiobutton/RadioButton";
import Utils from "../../../../../../../utils/Utils";

class ClassificazioneDelCaso extends Component {

    state = {
        classificazioneDelCaso: {
            malattiaDelCaso: "",
            classificazioneFinale: "",
            tipoDelCaso: "",
            corretto: []
        }
    }

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this)
    }

    componentDidMount() {
        let classificazioneDelCaso = this.state.classificazioneDelCaso
        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.classificazioneDelCaso) {
            let classificazioneDelCasoCopia = this.props.segnalazioneCopia.schedaSpeciale.classificazioneDelCaso
            for (let key in classificazioneDelCaso) {
                if (classificazioneDelCaso.hasOwnProperty(key) === classificazioneDelCasoCopia.hasOwnProperty(key)) {
                    classificazioneDelCaso[key] = classificazioneDelCasoCopia[key]
                } else {
                    classificazioneDelCaso[key] = ""
                }
            }
            this.setState({classificazioneDelCaso: classificazioneDelCaso})
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("classificazioneDelCaso", oggettoBE, corretto)

        } else {
            let corretto = this.controlloCorrettezza()
            let oggettoBE = this.createObjectBE()
            this.props.createOggettoBeAndcontrolloCorrettezza("classificazioneDelCaso", oggettoBE, corretto)
        }
    }

    riceviValore(field, event) {
        let classificazioneDelCaso = this.state.classificazioneDelCaso
        classificazioneDelCaso[field] = event.target.value
        this.setState({classificazioneDelCaso: classificazioneDelCaso})
        let corretto = this.controlloCorrettezza()
        let oggettoBE = this.createObjectBE()
        this.props.createOggettoBeAndcontrolloCorrettezza("classificazioneDelCaso", oggettoBE, corretto)
    }


    createObjectBE() {
        let oggettoBE = JSON.parse(JSON.stringify(this.state.classificazioneDelCaso))
        Utils.removeFieldFromObject(oggettoBE, "corretto")
        let res = Utils.removeEmptyValueFromObject(oggettoBE)
        return res
    }

    controlloCorrettezza() {
        let classificazioneDelCaso = this.state.classificazioneDelCaso
        classificazioneDelCaso.corretto = []

        if(!classificazioneDelCaso.tipoDelCaso) classificazioneDelCaso.corretto[0] = "Campo \"Caso di\" mancante";
        if(!classificazioneDelCaso.classificazioneFinale) classificazioneDelCaso.corretto[1] = "Campo \"Classificazione finale del caso\" mancante";
        if(!classificazioneDelCaso.malattiaDelCaso) classificazioneDelCaso.corretto[2] = "Campo \"Caso\" mancante";


        return classificazioneDelCaso.corretto

    }

    render() {
        const {t} = this.props

        const classificazioneDelCaso = (
            <div className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-4"}>
                        <p style={{marginTop: "0.5rem", color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.casoDi")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-8"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"malattiaDelCasoMorbillo"} name={"malattiaDelCaso"}
                                             label={t("SchedaSpecialeMorbillo.morbillo")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.classificazioneDelCaso.malattiaDelCaso === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"malattiaDelCasoRosolia"} name={"malattiaDelCaso"}
                                             label={t("SchedaSpecialeMorbillo.rosolia")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.classificazioneDelCaso.malattiaDelCaso === "2"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"malattiaDelCasoNonCaso"} name={"malattiaDelCaso"}
                                             label={t("SchedaSpecialeMorbillo.nonCaso")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"3"}
                                             checked={this.state.classificazioneDelCaso.malattiaDelCaso === "3"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>

                </div>

                <div className={"row"}>
                    <div className={"col-lg-4"}>
                        <p style={{marginTop: "0.5rem", color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.classificazioneFinale")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-8"}>
                        <div className={"row"}>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"classificazioneFinalePossibile"} name={"classificazioneFinale"}
                                             label={t("SchedaSpecialeMorbillo.possibile")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"1"}
                                             checked={this.state.classificazioneDelCaso.classificazioneFinale === "1"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"classificazioneFinaleProbabile"} name={"classificazioneFinale"}
                                             label={t("SchedaSpecialeMorbillo.probabile")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"2"}
                                             checked={this.state.classificazioneDelCaso.classificazioneFinale === "2"}>
                                </RadioButton>
                            </div>
                            <div className={"col-lg-2"}>
                                <RadioButton id={"classificazioneFinaleConfermato"} name={"classificazioneFinale"}
                                             label={t("SchedaSpecialeMorbillo.confermato")}
                                             style={{color: "black", fontSize: "16px"}}
                                             newRadio={true}
                                             onClick={this.riceviValore}
                                             smallLabel={true} value={"3"}
                                             checked={this.state.classificazioneDelCaso.classificazioneFinale === "3"}>
                                </RadioButton>
                            </div>
                        </div>
                    </div>

                </div>

                <div className={"row"}>
                    <div className={"col-lg-4"}>
                        <p style={{marginTop: "0.5rem", color: "black", fontWeight: "bold"}}>
                            {t("SchedaSpecialeMorbillo.caso")}
                            <span className={styles.mandatoryColor}>*</span>
                        </p>
                    </div>
                    <div className={"col-lg-8"}>
                        <RadioButton id={"tipoDelCaso1"} name={"tipoDelCaso"}
                                     label={t("SchedaSpecialeMorbillo.importato")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true} value={"1"}
                                     checked={this.state.classificazioneDelCaso.tipoDelCaso === "1"}>
                        </RadioButton>
                        <RadioButton id={"tipoDelCaso2"} name={"tipoDelCaso"}
                                     label={t("SchedaSpecialeMorbillo.autoctonoImportato")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true} value={"2"}
                                     checked={this.state.classificazioneDelCaso.tipoDelCaso === "2"}>
                        </RadioButton>
                        <RadioButton id={"tipoDelCaso3"} name={"tipoDelCaso"}
                                     label={t("SchedaSpecialeMorbillo.autoctonoAutoctono")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true} value={"3"}
                                     checked={this.state.classificazioneDelCaso.tipoDelCaso === "3"}>
                        </RadioButton>
                        <RadioButton id={"tipoDelCaso4"} name={"tipoDelCaso"}
                                     label={t("SchedaSpecialeMorbillo.autoctonoNonNoto")}
                                     style={{color: "black", fontSize: "16px"}}
                                     newRadio={true}
                                     onClick={this.riceviValore}
                                     smallLabel={true} value={"4"}
                                     checked={this.state.classificazioneDelCaso.tipoDelCaso === "4"}>
                        </RadioButton>
                    </div>
                </div>
            </div>
        )

        return (
            <div style={{marginTop: "2rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.classificazione")}</h6>
                <hr className={styles.hr}></hr>
                {classificazioneDelCaso}
            </div>
        );
    }

}

export default withTranslation('common')(ClassificazioneDelCaso)
